import { render, staticRenderFns } from "./packingListQuery.vue?vue&type=template&id=322e5b50&scoped=true&"
import script from "./packingListQuery.vue?vue&type=script&lang=js&"
export * from "./packingListQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e5b50",
  null
  
)

export default component.exports